import {ModuleWithProviders, NgModule} from '@angular/core';
import {
  BaseTableComponent,
  DebounceKeyupDirective,
  DebounceValuechangeDirective,
  DropDownListFilterComponent,
  DropDownListMenuFilterComponent,
  DurationAtomComponent,
  DurationPickerComponent,
  ImperialLengthPipe,
  KENDO_ANGULAR_GRID_CONFIG,
  KendoAngularGridConfig,
  KendoDropDownSearchableComponent,
  LengthEditorComponent,
  MeasurementTypeService,
  ObjectItemByValuePipe,
  ReactiveGroupBaseTableComponent,
  TimeWrapperComponent,
} from '@framewerx/kendo-angular-grid';

// Temporary NgModule bridge for the standalone Framewerx grid package.
@NgModule({
  imports: [
    BaseTableComponent,
    DebounceKeyupDirective,
    DebounceValuechangeDirective,
    DropDownListFilterComponent,
    DropDownListMenuFilterComponent,
    DurationAtomComponent,
    DurationPickerComponent,
    ImperialLengthPipe,
    KendoDropDownSearchableComponent,
    LengthEditorComponent,
    ObjectItemByValuePipe,
    ReactiveGroupBaseTableComponent,
    TimeWrapperComponent,
  ],
  exports: [
    BaseTableComponent,
    DebounceKeyupDirective,
    DebounceValuechangeDirective,
    DropDownListFilterComponent,
    DropDownListMenuFilterComponent,
    DurationAtomComponent,
    DurationPickerComponent,
    ImperialLengthPipe,
    KendoDropDownSearchableComponent,
    LengthEditorComponent,
    ObjectItemByValuePipe,
    ReactiveGroupBaseTableComponent,
    TimeWrapperComponent,
  ],
})
export class KendoAngularGridModule {
  static forRoot(config: KendoAngularGridConfig): ModuleWithProviders<KendoAngularGridModule> {
    return {
      ngModule: KendoAngularGridModule,
      providers: [
        MeasurementTypeService,
        {provide: KENDO_ANGULAR_GRID_CONFIG, useValue: config},
      ],
    };
  }
}

